import { render, staticRenderFns } from "./FeeDetail.vue?vue&type=template&id=554ecaae"
import script from "./FeeDetail.vue?vue&type=script&lang=ts"
export * from "./FeeDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports